// extracted by mini-css-extract-plugin
export default {"dashboardTopBar":"Dashboard_dashboardTopBar__3ZfQd"};